import React from 'react';
import { Cog6ToothIcon, ChartBarIcon, BanknotesIcon } from '@heroicons/react/24/solid';
import { useLocation, useNavigate } from 'react-router-dom';

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentTab = location.pathname === '/settings' ? 'settings' : 
                    location.pathname === '/analyze' ? 'analyze' : 
                    location.pathname === '/savings' ? 'savings' : 'home';

  // Preserve year/month params when navigating between home and savings
  const handleNavigate = (path: string) => {
    const params = new URLSearchParams(location.search);
    const year = params.get('year');
    const month = params.get('month');
    
    if (year && month) {
      navigate(`${path}?year=${year}&month=${month}`);
    } else {
      navigate(path);
    }
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white h-20 flex justify-center items-center z-40 w-full max-w-4xl mx-auto">
      <div className="flex space-x-8">
        <button
          className={`flex flex-col items-center justify-center w-14 h-14 rounded-full transition-all ${currentTab === 'home' ? 'bg-[#F8F9FA]' : ''}`}
          onClick={() => handleNavigate('/')}
          aria-label="Home"
        >
          <span className={`text-2xl font-bold ${currentTab === 'home' ? 'text-black' : 'text-gray-400'}`}>$</span>
        </button>
        <button
          className={`flex flex-col items-center justify-center w-14 h-14 rounded-full transition-all ${currentTab === 'savings' ? 'bg-[#F8F9FA]' : ''}`}
          onClick={() => handleNavigate('/savings')}
          aria-label="Savings"
        >
          <BanknotesIcon className={`w-8 h-8 ${currentTab === 'savings' ? 'text-black' : 'text-gray-400'}`} />
        </button>
        <button
          className={`flex flex-col items-center justify-center w-14 h-14 rounded-full transition-all ${currentTab === 'analyze' ? 'bg-[#F8F9FA]' : ''}`}
          onClick={() => navigate('/analyze')}
          aria-label="Analyze"
        >
          <ChartBarIcon className={`w-8 h-8 ${currentTab === 'analyze' ? 'text-black' : 'text-gray-400'}`} />
        </button>
        <button
          className={`flex flex-col items-center justify-center w-14 h-14 rounded-full transition-all ${currentTab === 'settings' ? 'bg-[#F8F9FA]' : ''}`}
          onClick={() => navigate('/settings')}
          aria-label="Settings"
        >
          <Cog6ToothIcon className={`w-8 h-8 ${currentTab === 'settings' ? 'text-black' : 'text-gray-400'}`} />
        </button>
      </div>
    </nav>
  );
} 